import React, { createContext, useContext, useState } from 'react'

import {
  ChecklistAction,
  IGetStartedCheckListContext,
} from '@interfaces/contexts/getStartedCheckListProvider'

const GET_STARTED_CHECK_LIST_KEY = 'GET_STARTED_CHECK_LIST'

const getStartedCheckListContext = createContext<IGetStartedCheckListContext>({
  checkList: undefined,
  selectedCheckList: undefined,
  setCheckListActionDone: () => {},
  setSelectedCheckList: () => {},
})

export const useGetStartedCheckList = () => {
  return useContext(getStartedCheckListContext)
}

export const GetStartedCheckListProvider = ({ children }: { children?: React.ReactNode }) => {
  const [checkList, setCheckList] = useState<Record<ChecklistAction, boolean>>(
    JSON.parse(localStorage.getItem(GET_STARTED_CHECK_LIST_KEY) || '{}'),
  )
  const [selectedCheckList, setSelectedCheckList] = useState<ChecklistAction>()

  const setCheckListActionDone = (checkListAction: ChecklistAction) => {
    if (!checkList?.[checkListAction]) {
      const newCheckList = { ...checkList, [checkListAction]: true }
      setCheckList(newCheckList)
      localStorage.setItem(GET_STARTED_CHECK_LIST_KEY, JSON.stringify(newCheckList))
      if (selectedCheckList === checkListAction) {
        setSelectedCheckList(undefined)
      }
    }
  }

  return (
    <getStartedCheckListContext.Provider
      value={{ checkList, selectedCheckList, setCheckListActionDone, setSelectedCheckList }}
    >
      {children}
    </getStartedCheckListContext.Provider>
  )
}
